<template>
  <div style="height: 100%;background-color: #fbfbfb">
    <div style="height: calc(100% - 20px);margin: 0 20px;padding-top: 20px">
      <div style="height: 50px;">
        <el-button type="primary" plain icon="el-icon-plus" @click="addOldPersonShow()">新增</el-button>
        <el-input v-model="searchName" prefix-icon="el-icon-search" placeholder="输入老人姓名" style="width: 250px" @blur="blurSearch"></el-input>
        <el-select v-fixZoom v-model="innursing" placeholder="请选择" style="width: 130px">
          <el-option v-for="item in innursingArr" :key="item.value" :label="item.name" :value="item.id"></el-option>
        </el-select>
        <el-button type="success" @click="searchBtn">查询</el-button>
      </div>
      <div style="max-height: calc(100% - 100px);overflow-y: auto">
        <el-table :data="tableData" border highlight-current-row ref="singleTable">
          <el-table-column
            type="index"
            label="序号"
            width="70"
            align="center">
          </el-table-column>
          <el-table-column
            prop="elderly_name"
            label="姓名"
            min-width="70"
            align="center">
          </el-table-column>
          <el-table-column
            label="性别"
            width="70"
            align="center">
            <template slot-scope="scope">
              <span>{{getgender(scope.row.gender)}}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="birth_date"
            label="出生日期"
            min-width="120"
            align="center">
            <template slot-scope="scope">
              <span>{{getAgeDesc(scope.row.birth_date)}}</span>
              (<span>{{scope.row.birth_date}}</span>)
            </template>
          </el-table-column>
          <el-table-column
            prop="newcard"
            label="身份证号"
            min-width="120"
            align="center">
          </el-table-column>
          <el-table-column align="center" label="操作" width="300">
            <template slot-scope="scope">
              <el-button size="mini" type="primary" plain @click="openDetails(scope.row)">档案</el-button>
              <el-button size="mini" type="warning" plain @click="openGrade(scope.row)">评估</el-button>
              <el-button size="mini" type="danger" plain @click="delOldPerson(scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div style="margin-top: 10px;height: 40px;text-align: center">
        <el-pagination v-fixZoom @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage"
                       :page-sizes="[10, 20, 50, 100]" :page-size="pageSize" :total="totalCells"
                       layout="total, sizes, prev, pager, next, jumper">
        </el-pagination>
      </div>
    </div>
    <el-dialog :visible.sync="addEditShow" v-if="addEditShow" width="1000px"
               :show-close="true" :close-on-click-modal="false" center class="all-open">
      <div class="title-top-alarm">
        <span>{{ titleShow }}</span><span style="font-size: 14px" v-if="!servicelistObj.isAdd"> / <span style="color: #999999">{{ servicelistObj.oldPersonRow.elderly_id }}</span></span>
        <div class="line-title"></div>
      </div>
      <add-old-person-list v-model="addEditShow" :servicelistObj="servicelistObj" @updateTable="updateTable"></add-old-person-list>
    </el-dialog>
<!--    fullscreen-->
    <el-dialog :visible.sync="evaluateShow" v-if="evaluateShow" width="1200px" top="5vh"
               :show-close="true" :close-on-click-modal="true" center class="all-open">
      <evaluate-history v-model="evaluateShow" :evaluateObj="evaluateObj"></evaluate-history>
    </el-dialog>
  </div>
</template>

<script>
import treeOrganize from './components/treeOrganize'
import addOldPersonList from './components/addOldPersonList'
import evaluateHistory from './components/evaluateHistory'
import {queryelderly, deleteelderly, searchelderly} from '../../api/yanglaoyuan'
export default {
  name: 'oldPersonManagement',
  components: {treeOrganize, addOldPersonList, evaluateHistory},
  data () {
    return {
      loading: false,
      treeOrg: [],
      treeNode: '',
      treeObj: {
        orgData: [],
        isNo: true
      },
      pageSize: 10,
      currentPage: 1,
      totalCells: 0,
      tableData: [],
      searchName: '',
      innursing: 0,
      innursingArr: [{id: 0, name: '全部'}, {id: 1, name: '在院'}, {id: 2, name: '离院'}],
      addEditShow: false,
      titleShow: '新增老人',
      servicelistObj: {
        entityArr: [],
        entityelderlyservice: '',
        oldPersonRow: '',
        treeOrg: [],
        isAdd: true
      },
      entityId: 0,
      evaluateShow: false,
      evaluateObj: {
        oldPersonRow: ''
      }
    }
  },
  created () {
    this.entityId = this.$store.state.user.LoginResp.entity_id
    this.getTableData()
  },
  methods: {
    getOrgArr (obj) {
      // console.log('obj', obj)
      if (obj.type === 'org') {
        this.treeOrg = obj.arr
        this.servicelistObj.treeOrg = obj.arr
      } else if (obj.type === 'node') {
        // 点击树组织
        this.treeNode = obj.node
        this.getTableData()
      } else if (obj.type === 'entityArr') { // 机构
        // console.log('entityArr', obj.arr)
        this.servicelistObj.entityArr = obj.arr
      }
    },
    getTableData () {
      this.searchName = ''
      let params = {
        page: this.currentPage,
        size: this.pageSize
      }
      let data = {
        e_id: this.entityId,
        innursing: this.innursing
      }
      queryelderly(params, data).then(res => {
        this.tableData = res.data.elderly.filter(item => {
          item.newcard = this.formatIDCard(item.id_number)
          return item
        })
        // console.log(this.tableData)
        this.totalCells = res.data.cnt
      }).catch(() => {})
    },
    formatIDCard (card) {
      // 身份证号脱敏，展示前4后4
      return card !== '' ? card.replace(/^(.{4})(?:\d+)(.{4})$/, '$1**********$2') : ''
    },
    searchTableData () {
      let params = {
        page: this.currentPage,
        size: this.pageSize
      }
      let data = {
        name: this.searchName
      }
      searchelderly(params, data).then(res => {
        this.tableData = res.data.elderly.filter(item => {
          item.newcard = this.formatIDCard(item.id_number)
          return item
        })
        this.totalCells = res.data.cnt
      }).catch(() => {})
    },
    getAgeDesc (birthDate) {
      let result = ''
      let age = this.util.getAgeByBirth(birthDate)
      if (age === '') {
        result = '--'
      } else {
        result = age + '岁'
      }
      return result
    },
    getgender (gender) {
      return this.util.getGender(gender)
      // if (gender === '0') {
      //   return '未知性别'
      // } else if (gender === '1') {
      //   return '男性'
      // } else if (gender === '2') {
      //   return '女性'
      // } else if (gender === '9') {
      //   return '未说明性别'
      // } else {
      //   return gender
      // }
    },
    addOldPersonShow () {
      this.titleShow = '新增老人'
      this.servicelistObj.oldPersonRow = ''
      this.servicelistObj.isAdd = true
      this.addEditShow = true
    },
    blurSearch () {
      if (this.searchName === '') {
        this.pageSize = 10
        this.currentPage = 1
        this.queryDataTable()
      }
    },
    searchBtn () {
      this.pageSize = 10
      this.currentPage = 1
      this.queryDataTable()
    },
    queryDataTable () {
      if (this.searchName !== '') {
        this.searchTableData()
      } else {
        this.getTableData()
      }
    },
    handleSizeChange (val) {
      this.pageSize = val
      this.queryDataTable()
    },
    handleCurrentChange (val) {
      this.currentPage = val
      this.queryDataTable()
    },
    delOldPerson (row) {
      this.$confirm('此操作将永久删除该老人【' + row.elderly_name + '】, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'error'
      }).then(() => {
        let data = {
          id: row.id
        }
        deleteelderly(data).then(res => {
          this.$notify({ title: '成功', message: '删除成功', type: 'success', duration: 2000 })
          if (this.tableData.length === 1 && this.currentPage > 1) {
            this.currentPage--
          }
          this.queryDataTable()
        }).catch(() => {})
      }).catch(() => {})
    },
    openGrade (row) {
      this.evaluateObj.oldPersonRow = row
      this.evaluateShow = true
      // this.$router.push({path: '/evaluateAbility', query: {ep_id: row.id}})
    },
    openDetails (row) {
      this.titleShow = '【' + row.elderly_name + '】'
      this.servicelistObj.oldPersonRow = row
      this.servicelistObj.isAdd = false
      this.addEditShow = true
      // let data = {
      //   e_id: row.e_id,
      //   ep_id: row.id
      // }
      // queryentityelderlyservice(data).then(res => {
      //   this.servicelistObj.entityelderlyservice = res.data.entityelderlyservice[0] ? res.data.entityelderlyservice[0] : ''
      //   this.addEditShow = true
      // }).catch(() => {})
    },
    updateTable () {
      this.queryDataTable()
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/oldPersonHome/oldPersonManagement.vue